<script>
export default {
  name: 'UlFormEditor',
  components: {
    EditorFroala: () => import('./editor.froala.vue'),
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: String,
      default: '',
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>
<template>
  <EditorFroala
    :value="value"
    :config="config"
    class="ul-form-editor"
    :tag="tag"
    :disabled="disabled"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
  />
</template>
<style lang="scss">
  .ul-form-editor {
    .fr-wrapper {
      height: 400px;
      overflow: auto;
    }
  }
</style>
